'use client'
import { useState } from 'react';

const useTabState = ({ settingsOverrides, }) => {
    var _a, _b, _c;
    const walletListViewSettings = (_a = settingsOverrides === null || settingsOverrides === void 0 ? void 0 : settingsOverrides.views) === null || _a === void 0 ? void 0 : _a.find((view) => view.type === 'wallet-list');
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const selectedTabSettings = selectedTabIndex === null
        ? undefined
        : (_b = walletListViewSettings === null || walletListViewSettings === void 0 ? void 0 : walletListViewSettings.tabs) === null || _b === void 0 ? void 0 : _b.items[selectedTabIndex];
    return {
        selectedTabIndex,
        selectedTabSettings,
        setSelectedTabIndex,
        tabsItems: (_c = walletListViewSettings === null || walletListViewSettings === void 0 ? void 0 : walletListViewSettings.tabs) === null || _c === void 0 ? void 0 : _c.items,
    };
};

export { useTabState };
